<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          v-if="this.$store.state.token!=''"
          :tabla="TablaName"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="true"
          :sIdTable="'idActaReunion'"
          :bShowMapDetails="false"
          :bActiveNew="false"
          :bGridAnidada="true"
          :aInfoTBDetalleExp="aDetallesExport"
          :aAccionesAdicionales="aAccionesAdicionales"
          @saveOk="createDetaill"
          @idSelect="getIdSelect"
          :aParametros="aParametrosAdicionalesObs"
          @nameField="getNameFieldSelect">
        >
          <template v-slot:slot-grid-anidada="props" >
            <grid-detalle
              v-if="onExtraerIdSelectGridAnidada(props.item) > 0"
              :tabla="'COP_recomendaciones_Actas'"
              :sIdTable="'idActa'"
              :bActiveFilter="false"
              :bActiveExport="false"
              :bSingleSelect="false"
              :bShowSelect="false"
              :bShowMapDetails="false"
              :bActiveSearch="false"
              :bActiveNew="false"
              :bGridDetalle="true"
              :nIdValor="onExtraerIdSelectGridAnidada(props.item)"
              :sCampoFiltro="'idActa'"
              :aParametros="aParametrosAdicionalesObs"
            />
      
            </template>
        </grid>  
      </v-col>
      <v-col md="12" sm="12" cols="12" class="pa-0 ma-0 mt-2">
        <grid-detalle
          v-if="parseInt(nIdSeleccionado) != 0"
          :tabla="'COPSECANCOL_Compromisos_Reunion$1'"
          :sIdTable="'idCompromisos_Reunion'"
          :bActiveFilter="false"
          :bActiveExport="false"
          :bSingleSelect="false"
          :bShowSelect="false"
          :bShowMapDetails="false"
          :bActiveSearch="false"
          :bActiveNew="false"
          :bGridDetalle="true"
          :nIdValor="parseInt(nIdSeleccionado)"
          :sCampoFiltro="'actareunionid'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import mxFunciones from '@/mixins/funciones.js'
import GridDetalle from '@/components/Grid/Grid.vue'
// import DialogFirmas from '@/components/DialogFirmas.vue' 

export default {
  name: 'ActaReunionCC',
  components: {
    grid,
    GridDetalle
  },
  mixins: [mxFunciones],
  data() {
    return {
      TablaName : 'COPSECANCOL_Actas_reunion$1',    // Nombre de la tabla a trabajar
      nIdSeleccionado  : 0,                 // Id seleccionado
      sNombreCampoFiltro : '',                 // Nombre del campo foreignKey
      aItemsBreadcrumbs: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlModuloOperaciones,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: '',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      aDetallesExport : [
        { 
          sTablaDetalle: 'COP_recomendaciones_Actas',
          sNombreCampoFiltroDetalle: 'idActa',
          sCampoParaFiltroTBPrincipal: 'idActaReunion',
        },
        { 
          sTablaDetalle: 'COPSECANCOL_Compromisos_Reunion$1',
          sNombreCampoFiltroDetalle: 'actareunionid',
          sCampoParaFiltroTBPrincipal: 'idActaReunion',
        },
      ],
      aAccionesAdicionales: [
        {
          componente: 'BtneGestionar',
          mensaje: 'Agregar Observaciones',
          oProps: {
            sTablaFormulario: 'COP_recomendaciones_Actas',
            sDetalleTitulo: 'Información de Acta',
            bDetalleFormulario: true,
            aParametrosEnvio: [
              {
                sParametro: 'idFormulario'
              },
              {
                sParametro: 'idActa',
                sCampoExtraer: 'idActaReunion' // Indica que para extraer es de una manera diferente que la que muestra
              },
            ]
          }
        }
      ],
      aParametrosAdicionalesObs:[
        "idFormulario=8", //Pendiente
      ],
    }
  },
  async mounted() {
    this.onValidarTokenSinLogin()
    this.tituloGrids = await this.getTitulo(this.TablaName)
    this.aItemsBreadcrumbs[2].text = this.tituloGrids
  },
  methods: {
    getIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
    createDetaill() {
  
    },
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>

</style>